// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"ip-z","slideIn":"jp-z"};